import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { PatientArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";
import { MenuCustomKeys } from '../menu-custom-keys';

export function entityKeyResolver<T extends PatientArea>(name: Extract<keyof T, string>): string { return name; };

export const patientMenu: MenuMainNode = {
    icon: 'patientsIconTemplate',
    title: 'Menu.Patients.Name',
    rootPath: '/patients',
  areaPermissionKey: permissionAreaKeyNameOf('patients'),
    children: [
        {
            title: 'Menu.Patients.InnerPatients.Name',
            abbreviation: 'Menu.Patients.InnerPatients.Abbreviation',
            link: '/patients',
            entityPermissionKey: entityKeyResolver("patients"),
            isSubmenuPath: true,
        },
        {
            title: 'Menu.Patients.ReferringPhysicians.Name',
            abbreviation: 'Menu.Patients.ReferringPhysicians.Abbreviation',
            link: '/patients/referring-physicians',
            entityPermissionKey: entityKeyResolver("referringPhysicians")
        },
        {
            title: 'Menu.Patients.NoahPatientMapping.Name',
            abbreviation: 'Menu.Patients.NoahPatientMapping.Abbreviation',
            link: '/patients/patient-mapping',
            entityPermissionKey: entityKeyResolver("patientMapping")
        },
        {
            customKey: MenuCustomKeys.eligibilitySearchKey,
            title: 'Menu.Patients.EligibilitySearch.Name',
            abbreviation: 'Menu.Patients.EligibilitySearch.Abbreviation',
            link: '/patients/eligibility-search',
            entityPermissionKey: entityKeyResolver("eligibilitySearch")
        }
    ]
};
